<template>
    <div class="trz_leave_settings">

           <!-- Abdullah added this code here -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance<span>
               <!-- AbdullahALC chnaged pageurl to api url -->
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance / Holidays</span>
        </h4>

        <div class="row no-margin mt-4">  <!-- Abdullah added this code here  -->
            <div class="ibox col-md-12 px-4">  <!-- Abdullah added this code here  -->
                <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>  <!-- Abdullah added this code here  -->
                <div class="ibox-title dashboard_title px-0">  <!-- Abdullah added this code here  -->
                    <h4>Holidays</h4>
                </div>

                <div class="ibox-content px-0 pt-4 employee-table-wrapper">  <!-- Abdullah added this code here  -->
                    <div class="row py-2 mb-3 pl-0 no-margin">  <!-- Abdullah added this code here  -->
                        <div class="col-sm-4">
                            <div class="custom-search">
                                <b-input-group class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search.. " v-model="search" @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>

                         <div class="col-sm-3 pr-0 cursor-pointer text-left ">
                            <b-input-group class="mb-2">
                                <!-- <b-input-group-prepend is-text>
                                    Year
                                </b-input-group-prepend> -->
                                <b-form-select id="year" name="year" v-model="year" :options="year_options" @change="getHoliDays"></b-form-select>
                            </b-input-group>


                        </div>
                        <div class="col-sm-5 pr-0 cursor-pointer text-right company-form-box-title" v-if="$acl['leave-attendances']==2">
                            <b-button v-b-modal.bv-modal-govt-holiday>Sync Government Holidays</b-button>
                            <b-button id="show-btn" @click="addNewHoliday()"><b-icon icon="plus" ></b-icon> Add Holiday</b-button>
                        </div>
                    </div>

        <b-overlay :show="showoverlay" rounded="sm">
            <table class="table dataTable">
                <thead>
                    <tr class="table-head">

                        <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>
                       <!-- alpha fix- maked both th text center  -->
                        <th class="text-center">Title</th>
                        <th class="text-center" v-if="$acl['leave-attendances']==2">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="hover-bg table-row border-bottom mx-2" v-for="holiday in paginatedData" :key="holiday.id">
                        <td>{{formatdate(holiday.holiday_date)}}</td>
                        <td>{{holiday_types[holiday.holiday_type].text}}</td>
                        <td>{{holiday.comment}}</td>
                        <td v-if="$acl['leave-attendances']==2">

                            <div class="float-right position-relative">
                                <b-button-toolbar v-if="checkGaterDate(holiday.holiday_date)">
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                        <b-button-group >

                                            <b-button variant="outline-secondary"  v-if="ce" @click="updateHoliday(holiday.id)">
                                                <b-icon icon="pencil"></b-icon> Edit
                                            </b-button>

                                        </b-button-group>
                                    </div>
                                </b-button-toolbar>
                            </div>
                        </td>
                    </tr>

                    <!-- Abdullah after live commented this  -->
                    <!-- <tr v-if="paginatedData.length > 0"><td :colspan="6">
                    <div class="row p-2 float-right" >
                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                    </div></td></tr>
                    <tr v-if="paginatedData.length == 0"><td :colspan="6">{{blankmsg}}</td></tr> -->
                </tbody>
            </table>

            <!-- Abdullah after live added this  -->
             <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{blankmsg}}</div>
                        <div v-else class="row py-2 no-margin">
                            <div class="col-md-12 p-0 no-margin">
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{pagination.total}} records found.</li>
                                </ul>
                                <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                            </div>
                        </div>
        </b-overlay>




                </div>
            </div>
        </div>
        <b-modal id="bv-modal-newholiday" size="lg" hide-footer title=" Add New Holiday">
            <div class="card-body">
                <div>Select Day / Range</div>
                <div class="row">
                    <div class="col-sm-6">From<b-form-datepicker id="holiday_one" @context="updateToDate()" :min="min"  v-model="holiday_one" :date-disabled-fn="dateDisabled" :start-weekday="fetchStartWeekday"></b-form-datepicker></div>
                    <div class="col-sm-6">To <b-form-datepicker id="holiday_two" :min="min"  v-model="holiday_two" :date-disabled-fn="dateDisabled" :start-weekday="fetchStartWeekday"></b-form-datepicker></div>

                </div>
                <div class='row mt-2'>

                    <div class="col-sm-6">
                        <b-form-group  id="holiday_type-group" label="Type" class="" label-for="holiday_type">
                            <b-form-select id="holiday_type" name="holiday_type" v-model="fdata.holiday_type" :options="holiday_types" ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group id="comment-group" label="Reason/Comment" label-for="comment">
                            <b-form-textarea id="comment" name="comment" rows="3" max-rows="6" no-resize v-model="fdata.comment"  v-validate="{required: true, min: 3 }" :state="validateState('comment')" aria-describedby="comment-feedback" data-vv-as="Reason/Comment"></b-form-textarea>
                            <b-form-invalid-feedback id="comment-feedback">{{ veeErrors.first('comment') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <div class="clearfix">

                            <div class="float-right font-italic">Day(s) : {{dateDiff}}</div>
                        </div>
                        <!-- <div class="clearfix">
                            <div class="float-right" ><b-button variant="success"  @click="saveHoliDays()" >Save</b-button></div>

                        </div> -->
                    </div>



                </div>

                 <div class="btn-wrapper text-center pt-5">
                        <b-button variant="primary"  @click="saveHoliDays()" >Submit</b-button>
                    </div>
            </div>
        </b-modal>

        <b-modal id="bv-modal-holiday"  hide-footer v-bind:title="holiday.holiday_date">
            <b-form @submit.stop.prevent="onSubmitHolidayUpdate">
                <input type="hidden" v-model="holiday.id" name="id">

                <b-form-group id="holiday_type-group" label="Type" label-for="holiday_type">
                    <b-form-select id="holiday_type" name="holiday_type" v-model="holiday.holiday_type" :options="holiday_types"></b-form-select>

                </b-form-group>

                <b-form-group id="holiday_date-group" label="Date" label-for="holiday_date">
                    <b-form-datepicker id="holiday_date" v-model="holiday.holiday_date" show-decade-nav :min="min"></b-form-datepicker>
                </b-form-group>

                <b-form-group id="comment_update-group" label="Reason/Comment" label-for="comment_update">
                    <b-form-textarea id="comment_update" name="comment" rows="3" max-rows="6" no-resize v-model="holiday.comment"  ></b-form-textarea>
                </b-form-group>

                <!-- alpha fix- added text-center maked success btn primary removed float-left and right from the btn  -->
                <div class="clearfix text-center">
                    <b-button type="submit" variant="primary" class="">Submit</b-button>
                    <b-button type="button" variant="danger" class="" @click="deleteHoliday(holiday.id)">Delete</b-button>
                </div>
            </b-form>
        </b-modal>

        <b-modal id="bv-modal-govt-holiday" size="lg" hide-footer title="Approved Government Holidays">
            <CompanyGovernmentHolidays  v-on:childToParent="getHoliDays"></CompanyGovernmentHolidays>
        </b-modal>


    </div>
</template>
<script>

    import moment from 'moment';
    import CompanyGovernmentHolidays from './CompanyGovernmentHolidays';

    export default{

        mounted() {

        },
        props: [],
        components: {
            CompanyGovernmentHolidays
        },
        data(){

            let sortOrders = {};
            let columns = [
                            {label: 'Date', name: 'holiday_date' },
                            {label: 'Type', name: 'holiday_type' },
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});


            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th two months prior
            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth())
            minDate.setDate(minDate.getDate() + 1)
            /*const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth() + 2)
            maxDate.setDate(15)*/
            const startdate = minDate

            return {

                ce : true,
                showoverlay : false,
                min: minDate,
                //max: maxDate,
                holiday_one:startdate , holiday_two:startdate,
                fdata : {id:0, holiday_one:startdate , holiday_two:startdate, days:null , comment:null , holiday_type:0},
                holiday : {},
                company_id : 0 ,

                week_holidays : [6],
                all_week_holidays : [6],
                week_start_day : 7,

                start_date : startdate,

                holidays : [],


               holiday_types:[
                    { value: "0", text: "Government" },
                    { value: "1", text: "Company" },
                ],

                year : now.getFullYear(),
                year_options : [
                    { text: '2019', value: '2019' },
                    { text: '2020', value: '2020' },
                    { text: '2021', value: '2021' },
                    { text: '2022', value: '2022' },
                    { text: '2023', value: '2023' },
                    { text: '2024', value: '2024' },
                    { text: '2025', value: '2025' },
                    { text: '2026', value: '2026' },
                ],

                columns: columns,
                sortKey: 'holiday_date',
                sortOrders: sortOrders,
                search:'',

                length: 10,
                pagination: {currentPage: 1, total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                blankmsg : 'Fetching data..',
                successmsg:'',


                // Abdullah after live added this
                temp_length: 20,
                length_options: [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],

            }
        },
        methods:{
            getCompanyLeaveSettings:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/leave/settings' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        console.log( response.data);
                        this.company_id =  response.data.company_id;
                        this.all_week_holidays = response.data.week_holidays;
                        this.week_holidays = response.data.week_holidays.split(',');
                        this.week_start_day =  response.data.week_start_day;

                        this.casual_leave =  response.data.casual_leave;
                        this.sick_leave =  response.data.sick_leave;
                        this.annual_leave =  response.data.annual_leave;
                    }

                }.bind(this));

            },
            dateDisabled(ymd, date) {
                const weekday = date.getDay()
                const day = date.getDate()

                return this.all_week_holidays.includes(weekday) ;
                //return weekday === 5 || weekday === 6
            },
            updateToDate:function()
            {
                this.holiday_two = this.holiday_one;
            },
            formatdate:function(x)
            {
                return moment(x).format('YYYY-MM-DD');
            },
            checkGaterDate(x)
            {

                return moment(x).isAfter(moment(new Date()).format('YYYY-MM-DD'));
            },
            updateHoliday : function(x)
            {
                axios.get(this.$api_url+'/company/holiday?id='+x , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    this.holiday = response.data;

                }.bind(this));
                this.$bvModal.show('bv-modal-holiday');
            },
            deleteHoliday : function(x)
            {
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this holiday.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        let currentObj = this;
                        //this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/company/holiday/delete', formData).then(function(response){


                            this.$bvToast.toast('Sucessfully deleted', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });



                            //this.holidays = response.data.holidays;
                            this.getHoliDays();
                            this.$bvModal.hide('bv-modal-holiday');

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.serverError(error);
                        });
                    }


                });
            },
            onSubmitHolidayUpdate:function()
            {
                let currentObj = this;
                let formData = new FormData();
                for (let [key, value] of Object.entries(this.holiday))
                {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    console.log(`${key}: ${value}`);
                }
                axios.post(this.$api_url+'/company/holiday', formData,)
                            .then(function (response)
                            {
                                if(response.data.status)
                                {
                                    //this.holidays = response.data.holidays;
                                    this.getHoliDays();
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                    this.$bvModal.hide('bv-modal-holiday');
                                }
                                else
                                {
                                    this.$bvToast.toast(response.data.message, {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true
                                        });
                                }


                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.serverError(error);
                            });
            },
            addNewHoliday()
            {
                this.resetForm();
                this.$bvModal.show('bv-modal-newholiday');
            },
            resetForm()
            {
                this.fdata = {};
            },
            getHoliDays:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/holidays?year='+this.year , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        //console.log( response.data);
                        this.holidays = response.data.holidays;
                    }

                }.bind(this));

                this.$bvModal.hide('bv-modal-govt-holiday');

            },
            saveHoliDays:function()
            {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    let currentObj = this;
                    let formData = new FormData();
                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        console.log(`${key}: ${value}`);
                    }
                    axios.post(this.$api_url+'/company/holidays', formData,)
                                .then(function (response)
                                {
                                    if(response.data.status)
                                    {
                                        //this.holidays = response.data.holidays;
                                        this.getHoliDays();
                                        this.$bvToast.toast('Saved!', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            });

                                        this.$bvModal.hide('bv-modal-newholiday');
                                    }
                                    else
                                    {
                                        this.$bvToast.toast(response.data.message, {
                                                title: `Warning`,
                                                variant: 'warning',
                                                solid: true
                                            });
                                    }


                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                });

                });
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            fetchDateDisabled()
            {
                return this.week_holidays;
            }
        },
        created: function(){
            this.getCompanyLeaveSettings();
            this.getHoliDays();

            this.sortBy('holiday_date');
        },
        computed:
        {
            dateDiff()
            {
                //fdata : {holiday_one:null , holiday_two:null, days:null , details:null},

                var holiday_one = moment(this.holiday_one);
                var holiday_two = moment(this.holiday_two);

                this.fdata.holiday_one = moment(String(this.holiday_one)).format('YYYY-MM-DD');
                this.fdata.holiday_two = moment(String(this.holiday_two)).format('YYYY-MM-DD');

                if(this.holiday_one === this.holiday_two)
                {
                    this.fdata.days = 1;
                    return 1;
                }
                let days = holiday_two.diff(holiday_one, 'days') // 1

                if(days > 0)
                {
                    ++days;
                    this.fdata.days = days;
                    return days;
                }
                else if(days < 0)
                {
                    this.fdata.days = 0;
                    return 'Invalid Date Range';
                }

            },
            fetchStartWeekday()
            {
                return this.week_start_day;
            },

            filteredData()
            {
                let filtered_list = this.holidays;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }

        }
    }
</script>
<style >
    .trz_leave_settings .custom-select{width: auto !important;}
    .trz_list li{margin-top:5px;}
</style>
